import removeViewportMeta from "./remove-viewport-meta";
import resizeIframe from "./resize-iframe";
import state from "./state";

/**
 * Sets html[data-convo] attribute to "minimized",
 * sets iframe positioning and scrolls to previous
 * scroll position
 *
 * @param {HTMLIFrameElement} iframe
 * @param {HTMLElement} convo
 * @returns {undefined}
 */
export default function minimize(iframe, convo) {
  if (!convo.hasAttribute("data-maximized")) {
    const { scrollPos } = state.values;
    document.documentElement.dataset.convo = "minimized";
    window.scrollTo(scrollPos.x, scrollPos.y);
    resizeIframe(iframe, convo);
    removeViewportMeta();
  }

  iframe.dispatchEvent(new CustomEvent("speakeasy:embed:minimize"));
}
